//import * as Helper from "../../../../utils/Helper";
import ApiService from "../../../../ApiService";

const EditService = {
    loadScreenView: (id, successCallback, failureCallback) => {
        ApiService.post("/web/admin/homework/aiprompts/edit/loadscreenview", { id }, successCallback, failureCallback);
    },
    savePrompt: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/homework/aiprompts/edit/save", vo, successCallback, failureCallback);
    },
};

export default EditService;
